import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { AdminJobOfferEditComponent } from "./admin-job-offer-edit.component";
import { TranslateModule } from "@ngx-translate/core";
import { NzButtonModule } from "ng-zorro-antd/button";
import { NzWaveModule } from "ng-zorro-antd/core/wave";
import { JobOfferFormModule } from "../job-offer-form/job-offer-form.module";
import { NzModalModule } from "ng-zorro-antd/modal";

@NgModule({
  declarations: [AdminJobOfferEditComponent],
  imports: [CommonModule, JobOfferFormModule, NzButtonModule, NzWaveModule, TranslateModule, NzModalModule],
})
export class AdminJobOfferEditModule {}
